export const useFirebaseApp = () => useNuxtApp().$clientFirebaseApp

export const useFirestore = () => {
  const { hiyieldNuxtLayerFirebase } = useAppConfig()
  const { initFirestore } = hiyieldNuxtLayerFirebase
  if (!initFirestore?.client) {
    throw new Error(`hiyieldNuxtLayerFirebase.initFirestore.client is not enabled in app.config.ts`)
  }
  return useNuxtApp().$clientFirebaseFirestore
}

export const useFirebaseAuth = () => {
  const { hiyieldNuxtLayerFirebase } = useAppConfig()
  const { initAuth } = hiyieldNuxtLayerFirebase
  if (!initAuth?.client) {
    throw new Error(`hiyieldNuxtLayerFirebase.initAuth.client is not enabled in app.config.ts`)
  }
  return useNuxtApp().$clientFirebaseAuth
}

export const useFirebaseStorage = () => {
  const { hiyieldNuxtLayerFirebase } = useAppConfig()
  const { initStorage } = hiyieldNuxtLayerFirebase
  if (!initStorage?.client) {
    throw new Error(`hiyieldNuxtLayerFirebase.initStorage.client is not enabled in app.config.ts`)
  }
  return useNuxtApp().$clientFirebaseStorage
}
